// Project pickers only offer projects whose current status is "En proceso".
// Resolves to the list of those projects ({ sProjectId, sName, ... }).
export function getInProgressProjects() {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("user-tk"),
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    },
  };
  return db
    .get(`${uri}/api/v1/project_status`, config)
    .then((statusResp) => {
      const enProceso = statusResp.data.status.find((s) => s.sName === "En proceso");
      if (!enProceso) return [];
      return db
        .get(`${uri}/api/v1/projects/?iPageNumber=1`, {
          ...config,
          params: { iItemsPerPage: 10000, sProjectStatusId: enProceso.sProjectStatusId },
        })
        .then((resp) => resp.data.projects);
    });
}

// Resolves to a Set with the ids of the "En proceso" projects.
export function getInProgressProjectIds() {
  return getInProgressProjects().then((projects) => new Set(projects.map((p) => p.sProjectId)));
}
